import { UntypedFormControl } from "@angular/forms";

export class PasswordValidator {
  public static strong(control: UntypedFormControl) {
    const hasNumber = /\d/.test(control.value);
    const hasUpper = /[A-Z]/.test(control.value);
    const hasLower = /[a-z]/.test(control.value);
    const hasProperLength = control.value.length > 6;
    const valid = hasNumber && hasUpper && hasLower && hasProperLength;
    if (!valid) {
      return { strong: { value: control.value } };
    }

    return null;
  }
}
